<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Név"
    show-overflow-tooltip
    min-width="160"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
